import React, { useContext } from 'react'
import Box from '../../../components/box'
import UploadPhotoButton from '../../../components/upload_photo_button'
import PhotoStepContext from './photo_step_context'

const PhotoStep: React.FC = () => {
  const {
    data: formData,
    setStepData: setStepFormData
  } = useContext(PhotoStepContext)

  const { photos } = formData

  const setPhotos = (photos: File[]): void => {
    setStepFormData({
      ...formData as any,
      photos
    })
  }

  return (
    <Box>
      <UploadPhotoButton
        multiple
        showPreview
        variant='contained'
        compress
        maxNumberOfImages={7}
        images={photos}
        previewStyles={{
          image: {
            width: '300px',
            height: 'auto',
            aspectRatio: '4 / 3'
          }
        }}
        onUpload={setPhotos}
      >
        Upload Photos
      </UploadPhotoButton>
    </Box>
  )
}

export default PhotoStep
